export default __webpack_public_path__ + "static/media/geofence_image.c027c9d2.png";